module.exports = __webpack_public_path__ + "static/media/ResponPic8.0a9c45cc.jpg";